/* eslint-disable */
export default function trackEvent(category, action, service, label = null) {
  const debug = false;
  if (window.dataLayer) {
    window.dataLayer.push({
      event: 'user_interaction',
      eventCategory: category,
      eventAction: action,
      eventLabel: label,
      eventValue: null,
      eventServices: service
    });
  }
  if (debug) {
    console.log(`Category: ${category}, Action: ${action}, Service: ${service}, Label: ${label}`);
  }
}
